import { render, staticRenderFns } from "./EditBannerGroup.vue?vue&type=template&id=144f27eb&scoped=true&"
import script from "./EditBannerGroup.vue?vue&type=script&lang=js&"
export * from "./EditBannerGroup.vue?vue&type=script&lang=js&"
import style0 from "./EditBannerGroup.vue?vue&type=style&index=0&id=144f27eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144f27eb",
  null
  
)

export default component.exports